/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Registration Initialization

import { CheckoutModalCoordinator } from './checkout/modal_coordinator';
import { RegistrationCheckoutController } from './checkout/controller.jsx';
import { Editor as RegistrationEditorController } from './editor_controller';

Slzr.jQuery(function($) {
  // Initialize editor on any pages with registration data and a form
  if (Slzr.Meta['registration']) {
    $('[data-registration="form"]').each(function(index, element) {
      const initial_state = Object.assign({}, Slzr.Meta['registration'], { payout_accounts: Slzr.Meta['registration-payout-accounts'] });
      const controller = new RegistrationEditorController(element, Slzr.Meta['event-id'], initial_state);
      $(element).data('registration', controller);

      // Update the experience state in the registration editor when the user changes the form value
      $(document).on('change', '[data-experience="true"]', function(event) {
        const experience = $(this).find('option').filter(':selected').data('experience-type');
        return controller.eventExperienceChanged(experience);
      });

      // Update the default stream URL in the registration editor when the form value changes
      $('#event_stream_url').on('change', function(event) {
        return controller.streamUrlChanged(this.value);
      });

      // Update the payout account ID in the registration editor when the form value changes
      return $('#event_payout_account_id').on('change', function(event) {
        return controller.eventPayoutAccountIdChanged(this.value);
      });
    });
  }

  // Initialize checkout code if the page has ticket offers
  if (Slzr.Meta['event-has-ticket-offers'] || Slzr.Meta['conference-has-ticket-offers']) {
    // The first instance of the checkout element for a given event_id is the one responsible for showing the modal,
    // regardless of which checkout element requests it be opened. This instance is also the one responsible for auto
    // opening on page load, if needed.
    const initializeCheckout = function() {
      const event_modal_coordinators = {};

      return $('[data-tickets="container"]').each(function(index, element) {
        if ($(element).data('checkout') == null) {
          // Extract event_id from the button's data-ticket-data attribute, falling back to the page's meta tag
          let coordinator; let is_modal_container;
          const ticket_data = $(element).data('ticket-data');
          const event_id = (ticket_data != null ? ticket_data['event_id'] : undefined) || Slzr.Meta['event-id'];

          if (event_modal_coordinators[event_id] != null) {
            // Not the first button for event_id
            is_modal_container = false;
            coordinator = event_modal_coordinators[event_id];
          } else {
            is_modal_container = true;
            coordinator = (event_modal_coordinators[event_id] = new CheckoutModalCoordinator);
          }

          const controller = new RegistrationCheckoutController(element, event_id, is_modal_container, coordinator);

          return $(element).data('checkout', controller);
        }
      });
    };

    // Listen for slzr:attendance:change events, to refresh the react component if necessary
    $(document).on('slzr:attendance:change', event => initializeCheckout());

    $(document).on('click', '[data-action="going"]', event => _.defer(() => initializeCheckout()));

    return initializeCheckout();
  }
});